import React from 'react';
import ConsolidateOrdersComponent from './../../components/consolidate/ConsolidateOrders';
import { reduxForm } from 'redux-form';
import { CONSOLIDATE_FORM_NAME } from 'Common/FormEnum';
import { ItemEnum } from 'Common/FieldEnum';
import { ItemStatusTextEnum } from 'Common/Constants/Enumeration/Consolidate';

class ConsolidateOrdersContainer extends React.Component {
  state = { expanded: { 0: {}, 1: {}, 2: {} } };
  setExpandedState = expanded => {
    this.setState({ expanded });
  };
  getTdProps = (state, rowInfo, column, instance) => {
    let style = {};
    const { id } = column;
    if (
      rowInfo &&
      rowInfo.row &&
      rowInfo.row.ItemStatus &&
      id === ItemEnum.ItemStatus
    ) {
      rowInfo.row.ItemStatus === ItemStatusTextEnum.ITEM_TOBE_ORDERED
        ? (style = {
            backgroundColor: '#b3ffb3',
          })
        : rowInfo.row.ItemStatus === ItemStatusTextEnum.ITEM_NOT_NEEDED
        ? (style = {
            backgroundColor: '#b3ccff',
          })
        : (style = {
            backgroundColor: '#ffb3b3',
          });
    }
    return {
      style,
    };
  };
  defaultFilterMethod = (filter, row, column) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id])
          .toLowerCase()
          .includes(filter.value.toLowerCase())
      : true;
  };
  consolidateMessageHandle = result => {
    if (!result) {
      this.props.redirectToRootPage();
    }
    this.props.clearOrderConsolidatedVerificationMsg();
  };
  render() {
    return (
      <ConsolidateOrdersComponent
        getTdProps={this.getTdProps}
        onSubmitClick={this.onSubmitClick}
        setExpandedState={this.setExpandedState}
        expanded={this.state.expanded}
        defaultFilterMethod={this.defaultFilterMethod}
        consolidateMessageHandle={this.consolidateMessageHandle}
        {...this.props}
      />
    );
  }
}
export const ConsolidateOrdersForm = reduxForm({
  form: CONSOLIDATE_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ConsolidateOrdersContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/containers/consolidate/ConsolidateOrdersForm.js